<template>
  <v-card
    class="pa-3"
    :class="$vuetify.breakpoint.mobile ? 'help-card-mobile radius-mobile' : 'radius'"
    :height="$vuetify.breakpoint.mobile ? '' : '100%'"
  >
    <div class="d-flex bg-titre">
      <div class="d-flex pl-3 mr-auto">
        <div class="titre-h2 secondary--text align-self-center">
          Ma synthèse
        </div>
      </div>
      
      <v-btn
        text
        class="align-self-center"
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <BaseLoader v-if="loading" />
    <BaseMessageServerError v-if="erreur" />
    <div
      v-if="!loading &&!erreur"
      class="synthese-content d-flex flex-column"
    >
      <div class="d-flex justify-center">
        <img
          src="@/assets/no-contrats.svg"
          alt="no-contrats"
        >
      </div>

      <div class="d-flex flex-column px-4 pb-3">
        <div
          v-for="(contenu, index) in synthese"
          :key="index"
        >
          <div class="d-flex pa-4">
            <v-icon
              class="mr-2 --text-branche align-self-start"
            >
              mdi-check
            </v-icon>
            <div
              class="texte texte-gris-fonce"
              :class="$vuetify.breakpoint.mobile ? 'w-300' : ''"
            >
              {{ contenu.message }}
            </div>
          </div>
          <v-divider v-if="synthese.length > index + 1" />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'

export default {
  name: 'SyntheseAdherentModal',
  components: { BaseLoader, BaseMessageServerError },
  data () {
    return {
      loading: false,
      erreur: false
    }
  },

  computed: {
    ...mapGetters({
      synthese: 'syntheseAnalyse/syntheseAnalyse'
    })
  },

  created () {
    this.loadSynthese()
  },

  methods: {
    ...mapActions({
      getSynthese: 'syntheseAnalyse/getSyntheseAnalyse'
    }),
    loadSynthese () {
      this.loading = true
      this.erreur = false
      this.getSynthese()
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.help-card-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  max-height: 90dvh;
  height: auto;

  display: flex;
  flex-direction: column;

  overflow: hidden;
}

.bg-titre {
  height: 80px;
  flex: 0 0 80px;

  position: sticky;
  top: 0;
  z-index: 10;

  background-color: white;
  width: 100%;
}

.synthese-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-top: 16px;
}

.radius {
  border-radius: 12px !important;
}

.radius-mobile {
  border-radius: 0 !important;
}

.w-300 {
  width: 300px;
}
</style>
